import DSIF from 'constants/time/dsif.const';
import { fromAnyDateToIso, fromAnyDateToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import isValidDateObject from 'utils/predicates/time/isValidDateObject.util';
import isValidIsoFormat from 'utils/predicates/time/isValidIsoFormat.util';
import isValidZuluFormat from 'utils/predicates/time/isValidZuluFormat.util';

const L = logger('parseIsoZulu');

const IS = Object.freeze({ valid: false, empty: false, formated: false, utc: false, iso: false, zulu: false });
const DF = Object.freeze({
  years: '',
  months: '',
  days: '',
  hours: '',
  minutes: '',
  seconds: '',
  milliseconds: '',
  offset: '',
  iso: '',
  zulu: '',
  is: IS,
});

const parseIsoZulu = (value) => {
  const empty = value === '' || value === null || value === void 1;
  const isIso = isValidIsoFormat(value);
  const isZulu = isValidZuluFormat(value);
  const formated = isIso || isZulu;

  try {
    if (!formated || empty) {
      return { ...DF, raw: value, is: { ...IS, empty, formated, iso: isIso, zulu: isZulu } };
    }

    const valid = isValidDateObject(new Date(value));
    const v = value.match(isIso ? DSIF.isoWithCaptures : DSIF.zuluWithCaptures);
    const utc = isZulu || v[8] === '+00:00' || v[8] === '-00:00';

    return {
      iso: isIso ? value : fromAnyDateToIso(value),
      zulu: isZulu ? value : fromAnyDateToZulu(value),
      raw: value,
      years: v[1],
      months: v[2],
      days: v[3],
      hours: v[4],
      minutes: v[5],
      seconds: v[6],
      milliseconds: v[7],
      offset: isZulu ? '+00:00' : v[8],
      is: { ...IS, valid, empty, formated, utc, iso: isIso, zulu: isZulu },
    };
  } catch (e) {
    L.warn('()', e);
    return { ...DF, raw: value, is: { ...IS, empty, formated, iso: isIso, zulu: isZulu } };
  }
};

export default parseIsoZulu;
